import { createSelector } from 'helpers/reselect'

export const getAppointment = state => state.appointment

export const getActivePromotionsList = createSelector(
  [getAppointment],
  ({ activePromotions }) => activePromotions
)

export const getRemovedPromotions = createSelector(
  [getAppointment],
  ({ removedPromotions }) => removedPromotions
)

export const getAppointmentSteps = createSelector(
  [getAppointment],
  ({ currentStep, previousStep }) => ({ currentStep, previousStep })
)
